import joi from 'joi';
import { i18n } from 'i18next';
import { loadTranslations } from '../load-translations';

const ns = ['joi', 'joi-loyalty'];

export function validateWithTranslations(value: any, schema: joi.ObjectSchema, i18nInstance: i18n) {
  const messages = loadTranslations(i18nInstance, ns);
  return schema.validate(value, {
    errors: {
      language: i18nInstance.language,
    },
    messages,
  });
}
